type NamedPerson = { firstName?: string | null; lastName?: string | null; preferredName?: string | null }

export const getFullName = ({ firstName, lastName, preferredName }: NamedPerson) => {
  return `${preferredName || firstName || ''} ${lastName || ''}`
}
